import { Model } from "./Model";
import { CrewTypes } from "../constants/enums";

export class Crew extends Model {
  static props = {
    id: { type: Number },
    identifier: { type: String },
    type: { type: String },
    crew_supervisor_id: { type: Number },
    crew_supervisor: { type: Object },
    crew_leader_id: { type: Number },
    crew_leader: { type: Object },
    laborers: { type: Array },
    note: { type: Object, default: { text: null } },
    notes_count: { type: Number }
  };

  /**
   * @param parameters  Object
   */
  constructor(parameters) {
    super(Crew.props, parameters);
  }

  get crewSupervisorName() {
    return this.crew_supervisor ? this.crew_supervisor.name : "";
  }

  get crewLeaderName() {
    return this.crew_leader ? this.crew_leader.name : "";
  }

  get crewLeaderEmail() {
    return this.crew_leader ? this.crew_leader.email : "";
  }

  get crewSupervisorPhone() {
    return this.crew_supervisor && this.crew_supervisor.primary_phone
      ? this.crew_supervisor.primary_phone.number
      : "";
  }

  get crewIconClass() {
    switch (this.type) {
      case CrewTypes.MASONRY:
        return "fal fa-chimney";

      default:
        return "";
    }
  }

  get crewLaborersCount() {
    return this.laborers ? this.laborers.length : 0;
  }
}
